/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CategoryType,
  CategoryTypeOptional,
  CategoryTypeMetaI,
  CategoryTypeTrackedI,
} from "./category-type";
import { CategoryTypeTracked, CategoryTypeMeta } from "./category-type";

/**
 *
 * @export
 * @interface CategoryBase
 */
export interface CategoryBaseOptional {
  /**
   *
   * @type {string}
   * @memberof CategoryBase
   */
  categoryName?: string;
  /**
   *
   * @type {string}
   * @memberof CategoryBase
   */
  description?: string;
  /**
   *
   * @type {boolean}
   * @memberof CategoryBase
   */
  hidden?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CategoryBase
   */
  forReporting?: boolean;
  /**
   *
   * @type {CategoryType}
   * @memberof CategoryBase
   */
  categoryType?: CategoryType;
}

export interface CategoryBase extends CategoryBaseOptional {
  /**
   *
   * @type {string}
   * @memberof CategoryBase
   */
  categoryName: string;
  /**
   *
   * @type {string}
   * @memberof CategoryBase
   */
  description: string;
  /**
   *
   * @type {boolean}
   * @memberof CategoryBase
   */
  hidden?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CategoryBase
   */
  forReporting?: boolean;
  /**
   *
   * @type {CategoryType}
   * @memberof CategoryBase
   */
  categoryType?: CategoryType;
}

export interface CategoryBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof CategoryBase
   */
  categoryName?: string;
  categoryNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CategoryBase
   */
  description?: string;
  descriptionIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CategoryBase
   */
  hidden?: boolean;
  hiddenIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CategoryBase
   */
  forReporting?: boolean;
  forReportingIsSet: boolean;
  /**
   *
   * @type {CategoryType}
   * @memberof CategoryBase
   */
  categoryType?: CategoryType;
  categoryTypeIsSet: boolean;
}

transformDatesMap.set("CategoryBase", function (model: CategoryBase) {});

export type CategoryBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  categoryName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  description: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  hidden: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  forReporting: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  categoryType: PropertyMeta<CategoryTypeMetaI>;
}>;

export var CategoryBaseMeta: CategoryBaseMetaI = {} as CategoryBaseMetaI;
CategoryBaseMeta = typeMeta("CategoryBase", {
  categoryName: propertyMeta(
    "categoryName",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  description: propertyMeta(
    "description",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  hidden: propertyMeta("hidden", false, false, false, MetaTypesBase.boolean),
  forReporting: propertyMeta(
    "forReporting",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  categoryType: propertyMeta(
    "categoryType",
    false,
    false,
    false,
    CategoryTypeMeta,
  ),
});

const metaI = CategoryBaseMeta;

registerMeta(() => {});

export class CategoryBaseTracked implements CategoryBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  categoryName__I?: string = undefined;
  categoryNameIsSet: boolean = false;
  set categoryName(v: undefined | string) {
    if (v !== undefined) {
      this.categoryName__I = v;
      this.categoryNameIsSet = true;
    } else {
      this.categoryName__I = v || undefined;
      this.categoryNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get categoryName() {
    return this.categoryName__I;
  }
  description__I?: string = undefined;
  descriptionIsSet: boolean = false;
  set description(v: undefined | string) {
    if (v !== undefined) {
      this.description__I = v;
      this.descriptionIsSet = true;
    } else {
      this.description__I = v || undefined;
      this.descriptionIsSet = true;
    }
    this.changeTracker = true;
  }
  get description() {
    return this.description__I;
  }
  hidden__I?: boolean = undefined;
  hiddenIsSet: boolean = false;
  set hidden(v: undefined | boolean) {
    if (v !== undefined) {
      this.hidden__I = v;
      this.hiddenIsSet = true;
    } else {
      this.hidden__I = v || undefined;
      this.hiddenIsSet = false;
    }
    this.changeTracker = true;
  }
  get hidden() {
    return this.hidden__I;
  }
  forReporting__I?: boolean = undefined;
  forReportingIsSet: boolean = false;
  set forReporting(v: undefined | boolean) {
    if (v !== undefined) {
      this.forReporting__I = v;
      this.forReportingIsSet = true;
    } else {
      this.forReporting__I = v || undefined;
      this.forReportingIsSet = false;
    }
    this.changeTracker = true;
  }
  get forReporting() {
    return this.forReporting__I;
  }
  categoryType__I?: CategoryType = undefined;
  categoryTypeIsSet: boolean = false;
  set categoryType(v: undefined | CategoryType) {
    if (v !== undefined) {
      this.categoryType__I = v;
      this.categoryTypeIsSet = true;
    } else {
      this.categoryType__I = v || undefined;
      this.categoryTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get categoryType() {
    return this.categoryType__I;
  }
  constructor(config?: CategoryBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CategoryBaseOptional,
    options?: AssignOptions,
  ): CategoryBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.categoryName &&
      this.categoryNameApplyFilter(optionsRequired.filter)
    ) {
      this.categoryName = config.categoryName;
      if (optionsRequired.unassign) this.categoryNameIsSet = false;
      else this.categoryNameIsSet = true;
    }
    if (
      config.description &&
      this.descriptionApplyFilter(optionsRequired.filter)
    ) {
      this.description = config.description;
      if (optionsRequired.unassign) this.descriptionIsSet = false;
      else this.descriptionIsSet = true;
    }
    if (config.hidden && this.hiddenApplyFilter(optionsRequired.filter)) {
      this.hidden = config.hidden;
      if (optionsRequired.unassign) this.hiddenIsSet = false;
      else this.hiddenIsSet = true;
    }
    if (
      config.forReporting &&
      this.forReportingApplyFilter(optionsRequired.filter)
    ) {
      this.forReporting = config.forReporting;
      if (optionsRequired.unassign) this.forReportingIsSet = false;
      else this.forReportingIsSet = true;
    }
    if (
      config.categoryType &&
      this.categoryTypeApplyFilter(optionsRequired.filter)
    ) {
      this.categoryType = config.categoryType;
      if (optionsRequired.unassign) this.categoryTypeIsSet = false;
      else this.categoryTypeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CategoryBaseTrackedI {
    const cloned = {} as CategoryBaseTrackedI;
    if (
      this.categoryNameIsSetDeep() &&
      this.categoryNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoryNameIsSet = true;
      cloned.categoryName = this.categoryName;
    } else {
      //cloned.categoryNameIsSet = false
    }
    if (
      this.descriptionIsSetDeep() &&
      this.descriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.descriptionIsSet = true;
      cloned.description = this.description;
    } else {
      //cloned.descriptionIsSet = false
    }
    if (
      this.hiddenIsSetDeep() &&
      this.hiddenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.hiddenIsSet = true;
      cloned.hidden = this.hidden;
    } else {
      //cloned.hiddenIsSet = false
    }
    if (
      this.forReportingIsSetDeep() &&
      this.forReportingApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.forReportingIsSet = true;
      cloned.forReporting = this.forReporting;
    } else {
      //cloned.forReportingIsSet = false
    }
    if (
      this.categoryTypeIsSetDeep() &&
      this.categoryTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoryTypeIsSet = true;
      cloned.categoryType = this.categoryType;
    } else {
      //cloned.categoryTypeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CategoryBaseTrackedI {
    if (!this.categoryNameApplyFilter(filter)) this.categoryNameIsSet = false;

    if (!this.descriptionApplyFilter(filter)) this.descriptionIsSet = false;

    if (!this.hiddenApplyFilter(filter)) this.hiddenIsSet = false;

    if (!this.forReportingApplyFilter(filter)) this.forReportingIsSet = false;

    if (!this.categoryTypeApplyFilter(filter)) this.categoryTypeIsSet = false;

    return this;
  }
  categoryNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CategoryBaseMeta.categoryName,
      CategoryBaseMeta,
      this.categoryName,
      this,
    );
  }
  categoryNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoryNameIsSet && this.categoryNameApplyFilter(filter))
      return true;

    return false;
  }
  descriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CategoryBaseMeta.description,
      CategoryBaseMeta,
      this.description,
      this,
    );
  }
  descriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.descriptionIsSet && this.descriptionApplyFilter(filter))
      return true;

    return false;
  }
  hiddenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CategoryBaseMeta.hidden, CategoryBaseMeta, this.hidden, this);
  }
  hiddenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.hiddenIsSet && this.hiddenApplyFilter(filter)) return true;

    return false;
  }
  forReportingApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CategoryBaseMeta.forReporting,
      CategoryBaseMeta,
      this.forReporting,
      this,
    );
  }
  forReportingIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.forReportingIsSet && this.forReportingApplyFilter(filter))
      return true;

    return false;
  }
  categoryTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CategoryBaseMeta.categoryType,
      CategoryBaseMeta,
      this.categoryType,
      this,
    );
  }
  categoryTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoryTypeIsSet && this.categoryTypeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.categoryNameIsSetDeep(filter)) return true;
    if (this.descriptionIsSetDeep(filter)) return true;
    if (this.hiddenIsSetDeep(filter)) return true;
    if (this.forReportingIsSetDeep(filter)) return true;
    if (this.categoryTypeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
